const trim = (value) => (typeof value === 'string' ? value.trim() : '');
const isHomePath = (path) => {
    const normalized = path.replace(/\/+$/, '') || '/';
    return normalized === '/';
};
export const buildDefaultSeoTitle = (projectName) => {
    const name = trim(projectName);
    return name ? `${name} – Online bestellen` : 'Online bestellen';
};
export const resolvePageTitle = ({ siteConfig, routePath, routeMeta }) => {
    const projectName = siteConfig?.project?.name;
    const seoTitle = trim(siteConfig?.seo?.title);
    const routeTitle = trim(routeMeta?.title);
    const home = isHomePath(routePath);
    if (home) {
        if (seoTitle)
            return seoTitle;
        if (routeTitle && projectName)
            return `${routeTitle} – ${projectName}`;
        return buildDefaultSeoTitle(projectName);
    }
    if (routeTitle && projectName)
        return `${routeTitle} – ${projectName}`;
    if (routeTitle)
        return routeTitle;
    if (seoTitle)
        return seoTitle;
    return buildDefaultSeoTitle(projectName);
};
export const resolvePageDescription = ({ siteConfig, routePath, routeMeta }) => {
    const seoDescription = trim(siteConfig?.seo?.description);
    const contentDescription = trim(siteConfig?.content?.description);
    const routeDescription = trim(routeMeta?.description);
    const home = isHomePath(routePath);
    if (home) {
        if (seoDescription)
            return seoDescription;
        if (contentDescription)
            return contentDescription;
        return routeDescription;
    }
    return routeDescription || seoDescription || contentDescription;
};
export const resolveOgImage = (siteConfig) => {
    return (trim(siteConfig?.seo?.ogImage)
        || trim(siteConfig?.branding?.heroImageUrl)
        || trim(siteConfig?.branding?.logoUrl)
        || '');
};
export const resolveCanonicalUrl = (routePath) => {
    if (typeof window === 'undefined')
        return '';
    const origin = window.location.origin;
    const path = routePath.startsWith('/') ? routePath : `/${routePath}`;
    if (path === '/' || path === '')
        return `${origin}/`;
    return `${origin}${path.replace(/\/+$/, '')}`;
};
const setMetaTag = (selector, attribute, value) => {
    if (typeof document === 'undefined')
        return;
    let el = document.querySelector(selector);
    if (!el) {
        el = document.createElement('meta');
        const match = selector.match(/\[(name|property)="([^"]+)"\]/);
        if (match)
            el.setAttribute(match[1], match[2]);
        document.head.appendChild(el);
    }
    el.setAttribute(attribute, value);
};
const setCanonicalLink = (href) => {
    if (typeof document === 'undefined' || !href)
        return;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
    }
    link.href = href;
};
export const applyPageSeo = (input) => {
    if (typeof document === 'undefined')
        return;
    const title = resolvePageTitle(input);
    const description = resolvePageDescription(input);
    const ogImage = resolveOgImage(input.siteConfig);
    const noIndex = input.siteConfig?.seo?.noIndex === true;
    const siteName = trim(input.siteConfig?.project?.name);
    const canonical = resolveCanonicalUrl(input.routePath);
    document.title = title;
    if (description) {
        setMetaTag('meta[name="description"]', 'content', description);
        setMetaTag('meta[property="og:description"]', 'content', description);
    }
    setMetaTag('meta[property="og:title"]', 'content', title);
    setMetaTag('meta[name="robots"]', 'content', noIndex ? 'noindex, nofollow' : 'index, follow');
    if (siteName) {
        setMetaTag('meta[property="og:site_name"]', 'content', siteName);
    }
    if (ogImage) {
        setMetaTag('meta[property="og:image"]', 'content', ogImage);
    }
    if (typeof window !== 'undefined') {
        setMetaTag('meta[property="og:url"]', 'content', window.location.href);
    }
    if (canonical && !noIndex) {
        setCanonicalLink(canonical);
    }
};
